import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API = (process.env.REACT_APP_API_BASE || '').replace(/\/api$/, '') || (window.location.protocol === 'https:' ? '' : `http://${window.location.hostname}:5000`);

const PRESETS = [
  { name: 'Clinic hours inquiry', keywords: ['hours', 'timing', 'open', 'kab khulta'], response: 'Our clinic is open Mon-Sat 9AM-9PM. Sunday closed.' },
  { name: 'Location', keywords: ['location', 'address', 'where', 'kahan'], response: 'We are at [ADDRESS]. Google Maps: [LINK]' },
  { name: 'Appointment booking', keywords: ['appointment', 'book', 'visit', 'milna'], response: 'To book, please share preferred date/time or call us at [PHONE].' },
  { name: 'Price inquiry', keywords: ['price', 'cost', 'fees', 'charges', 'kharcha'], response: 'Our consultation is ₹300. For treatment costs, please visit for examination.' },
  { name: 'Emergency', keywords: ['emergency', 'urgent', 'pain'], response: 'For emergencies call [PHONE] immediately. We have 24/7 helpline.' }
];

export default function WhatsAppAutoReplyPage() {
  const [rules, setRules] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [showTest, setShowTest] = useState(false);
  const [testMessage, setTestMessage] = useState('');
  const [testResult, setTestResult] = useState(null);
  const [form, setForm] = useState({ name: '', keywords: '', matchMode: 'any', response: '', priority: 0, businessHoursOnly: false });

  const headers = { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` };

  const load = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/api/saas/wa-autoreply`, { headers });
      setRules(data || []);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  useEffect(() => { load(); }, []);

  const save = async (preset) => {
    const p = preset || form;
    const payload = {
      name: p.name,
      keywords: Array.isArray(p.keywords) ? p.keywords : p.keywords.split(',').map(k => k.trim()).filter(Boolean),
      matchMode: p.matchMode || 'any',
      response: p.response,
      priority: p.priority || 0,
      businessHoursOnly: !!p.businessHoursOnly
    };
    if (!payload.name || !payload.keywords.length || !payload.response) return alert('Name, keywords, response required');
    try {
      await axios.post(`${API}/api/saas/wa-autoreply`, payload, { headers });
      setForm({ name: '', keywords: '', matchMode: 'any', response: '', priority: 0, businessHoursOnly: false });
      setShowAdd(false);
      load();
    } catch (err) { alert('Save failed'); }
  };

  const toggle = async (id, enabled) => {
    try {
      await axios.patch(`${API}/api/saas/wa-autoreply/${id}`, { enabled: !enabled }, { headers });
      load();
    } catch { alert('Toggle failed'); }
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this rule?')) return;
    try {
      await axios.delete(`${API}/api/saas/wa-autoreply/${id}`, { headers });
      load();
    } catch { alert('Delete failed'); }
  };

  const testRule = async () => {
    if (!testMessage) return alert('Enter a test message');
    try {
      const { data } = await axios.post(`${API}/api/saas/wa-autoreply/test`, { message: testMessage }, { headers });
      setTestResult(data);
    } catch { alert('Test failed'); }
  };

  return (
    <div style={{ padding: 24, maxWidth: 1200, margin: '0 auto' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
        <h2 style={{ margin: 0 }}>🤖 Auto-Reply Rules</h2>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={() => { setShowTest(true); setTestResult(null); }} style={btnSecondary}>🧪 Test Matcher</button>
          <button onClick={() => setShowAdd(true)} style={btnPrimary}>+ New Rule</button>
        </div>
      </div>

      <div style={{ background: '#eff6ff', padding: 12, borderRadius: 6, marginBottom: 16, fontSize: 13 }}>
        💡 Rules are checked in priority order (highest first). Match modes: <strong>any</strong> (one keyword hits) · <strong>all</strong> (every keyword required) · <strong>exact</strong> (whole message matches).
      </div>

      <div style={{ marginBottom: 16, padding: 12, background: 'white', borderRadius: 8 }}>
        <strong style={{ fontSize: 13 }}>Quick start from preset:</strong>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
          {PRESETS.map(p => (
            <button key={p.name} onClick={() => save(p)} style={{ ...miniBtn, background: '#dcfce7' }}>
              + {p.name}
            </button>
          ))}
        </div>
      </div>

      {loading ? <div>Loading...</div> : (
        <div style={{ background: 'white', borderRadius: 8, boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead style={{ background: '#f9fafb' }}>
              <tr>
                <th style={th}>Name</th>
                <th style={th}>Keywords</th>
                <th style={th}>Mode</th>
                <th style={th}>Priority</th>
                <th style={th}>Triggers</th>
                <th style={th}>Status</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {rules.map(r => (
                <tr key={r._id} style={{ borderTop: '1px solid #e5e7eb' }}>
                  <td style={td}>
                    <strong>{r.name}</strong>
                    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{r.response.slice(0, 60)}{r.response.length > 60 ? '...' : ''}</div>
                  </td>
                  <td style={td}>{r.keywords.join(', ')}</td>
                  <td style={td}>{r.matchMode}</td>
                  <td style={td}>{r.priority}</td>
                  <td style={td}>{r.triggerCount}</td>
                  <td style={td}>
                    <label style={{ cursor: 'pointer' }}>
                      <input type="checkbox" checked={r.enabled} onChange={() => toggle(r._id, r.enabled)} /> {r.enabled ? 'On' : 'Off'}
                    </label>
                  </td>
                  <td style={td}>
                    <button onClick={() => remove(r._id)} style={{ ...miniBtn, color: '#ef4444' }}>Delete</button>
                  </td>
                </tr>
              ))}
              {rules.length === 0 && (
                <tr><td colSpan={7} style={{ ...td, textAlign: 'center', color: '#888', padding: 40 }}>
                  No rules yet. Add from preset or create custom.
                </td></tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {showAdd && (
        <Modal onClose={() => setShowAdd(false)} title="New Auto-Reply Rule">
          <input placeholder="Rule name" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={input} />
          <input placeholder="Keywords (comma separated)" value={form.keywords} onChange={e => setForm({ ...form, keywords: e.target.value })} style={input} />
          <select value={form.matchMode} onChange={e => setForm({ ...form, matchMode: e.target.value })} style={input}>
            <option value="any">Any keyword matches</option>
            <option value="all">All keywords required</option>
            <option value="exact">Exact message match</option>
          </select>
          <textarea placeholder="Response text" value={form.response} onChange={e => setForm({ ...form, response: e.target.value })} style={{ ...input, minHeight: 100 }} />
          <input type="number" placeholder="Priority (higher wins)" value={form.priority} onChange={e => setForm({ ...form, priority: +e.target.value })} style={input} />
          <label style={{ display: 'block', marginBottom: 10 }}>
            <input type="checkbox" checked={form.businessHoursOnly} onChange={e => setForm({ ...form, businessHoursOnly: e.target.checked })} /> Business hours only (9am-9pm)
          </label>
          <button onClick={() => save()} style={btnPrimary}>Save Rule</button>
        </Modal>
      )}

      {showTest && (
        <Modal onClose={() => setShowTest(false)} title="🧪 Test Matcher">
          <p style={{ fontSize: 13, color: '#666' }}>Simulate an incoming message to see which rule fires.</p>
          <input placeholder="e.g. what are your timings?" value={testMessage} onChange={e => setTestMessage(e.target.value)} style={input} />
          <button onClick={testRule} style={btnPrimary}>Test</button>
          {testResult && (
            <div style={{ marginTop: 16, padding: 12, background: testResult.matched ? '#dcfce7' : '#fee2e2', borderRadius: 6 }}>
              {testResult.matched ? (
                <>
                  <strong>✓ Matched: {testResult.rule.name}</strong>
                  <div style={{ marginTop: 8, fontSize: 13 }}>{testResult.rule.response}</div>
                </>
              ) : <strong>✗ No rule matched</strong>}
            </div>
          )}
        </Modal>
      )}
    </div>
  );
}

function Modal({ children, onClose, title }) {
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
      <div style={{ background: 'white', borderRadius: 8, padding: 24, width: '90%', maxWidth: 560, maxHeight: '90vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
          <h3 style={{ margin: 0 }}>{title}</h3>
          <button onClick={onClose} style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer' }}>×</button>
        </div>
        {children}
      </div>
    </div>
  );
}

const input = { padding: 10, border: '1px solid #d1d5db', borderRadius: 6, fontSize: 14, marginBottom: 10, width: '100%', boxSizing: 'border-box' };
const btnPrimary = { padding: '8px 16px', background: '#25D366', color: 'white', border: 'none', borderRadius: 6, cursor: 'pointer', fontWeight: 600 };
const btnSecondary = { padding: '8px 16px', background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, cursor: 'pointer' };
const miniBtn = { padding: '4px 10px', fontSize: 12, background: '#f3f4f6', border: '1px solid #d1d5db', borderRadius: 4, cursor: 'pointer' };
const th = { padding: 12, textAlign: 'left', fontSize: 13, fontWeight: 600, color: '#374151' };
const td = { padding: 12, fontSize: 14 };
